var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeedbackIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9965 1C10.8265 1.00068 8.69729 1.58993 6.83571 2.705C4.97413 3.82007 3.44986 5.4192 2.42524 7.33206C1.40063 9.24492 0.914052 11.3999 1.01733 13.5674C1.12061 15.7349 1.80987 17.8339 3.01171 19.6407L1 24.9929L7.73647 23.7748C9.35859 24.5675 11.1387 24.9838 12.9441 24.9928C14.7496 25.0017 16.5337 24.603 18.1636 23.8265C19.7935 23.0499 21.2271 21.9154 22.3575 20.5077C23.4879 19.0999 24.286 17.4552 24.6923 15.6961C25.0986 13.9369 25.1026 12.1088 24.704 10.3479C24.3054 8.58699 23.5144 6.93878 22.3902 5.52611C21.2659 4.11344 19.8373 2.97275 18.2108 2.18907C16.5843 1.40539 14.8019 0.998936 12.9965 1V1Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeedbackIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/feedback_icon.b32a9d879417a72fce9696ba41047fb9.svg";